<template>
    <div :class="{ 'h-100': loading || !notifications.length }">
        <div v-if="loading" style="height: 100%; width: 100%" class=" m-auto d-flex justify-center align-center">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>
        <v-row v-if="!loading && notifications.length" class="px-2 " :class="{ 'mt-3': !loading }">
            <!-- <div > -->
            <v-col  cols="12" v-for="(item, index) in notifications" :key="index" class="">
                <v-card  class="rounded-BigLg" height="80">
                    <v-card-text class="pe-0 py-0 h-100" style="height: 70px">
                        <v-row class="h-100">
                            <v-col cols="10" class="d-flex justify-center" align-self="center">
                                <span class="text-start black--text">
                                    {{ item.Message }}
                                </span>
                            </v-col>

                            <v-col cols="2" class="d-flex justify-end ps-0 py-0" align-self="center">
                                <v-btn color="secondary" height="80" style="" small class="rounded-btn-card">
                                    <v-icon color="white"> mdi-bell </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- </div> -->
            <!-- notifications -->
        </v-row>

        <div v-if="!loading && !notifications.length" style="height: 100%; width: 100%" class=" m-auto d-flex flex-column justify-center align-center">
            <v-icon size="30" color="primary">
                mdi-bell-off
            </v-icon>
            <span>
              لا يوجد اشعارت لعرضها!
            </span>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import { tripType } from '@/helper/enums'
export default {
    data () {
        return {
            loading: false,
            notifications: [],
            tripType
        }
    },

    methods: {
        moment
    },

    created () {
        this.loading = true
        this.$store.dispatch('notification/getNotification', {
            centerId: localStorage.getItem('centerId'),
            userName: localStorage.getItem('userName'),
            dateTime: moment().format('YYYY-MM-DD')
            // dateTime: '2025-10-23'
        }).then(({ data }) => {
            this.notifications = this.$route.query.isStart === 'true' || this.$route.query.isStart === true
                ? data.filter(c => c.TripType === tripType.roundTrip || c.TripType === tripType.oneWay)
                : data.filter(c => c.TripType === tripType.roundTrip || c.TripType === tripType.returnOnly)
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>
